import { Component, OnInit, Output, EventEmitter, OnDestroy, OnChanges, Input, ViewChild, ElementRef } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { Store, select } from '@ngrx/store';
import { ApplicationState } from 'src/app/modules/acbcr/common/state/app.state';
import { Subject } from 'rxjs';
import { getSelectedHolding } from 'src/app/modules/acbcr/common/state/reducers/holdings.reducers';
import { takeUntil } from 'rxjs/operators';
import { ReproductionsTableService } from 'src/app/modules/acbcr/common/services/reproductions-table.service';
import { UIHelper } from 'src/app/modules/acbcr/components/common/helper/ui-helper';


@Component({
  selector: 'app-add-edit-reproductie-form',
  templateUrl: './add-edit-reproductie-form.component.html',
  styleUrls: ['./add-edit-reproductie-form.component.scss']
})
export class AddEditReproductieFormComponent implements OnInit, OnChanges, OnDestroy {
  @ViewChild('autModal') autModal: ElementRef;

  @Input() data;
  @Output() callbackResult = new EventEmitter();
  @Output() closeForm = new EventEmitter();

  destroy$: Subject<boolean> = new Subject<boolean>();
  readonly addReproduction = 'add-reproductie';
  readonly editReproduction = 'edit-reproductie';

  loadingDataSpinner = false;
  monta;
  reprModalType: string;

  fileId = null;
  fileName = null;
  openConfirmModal = false;
  reproductionForm: UntypedFormGroup;
  isSuperAdmin = false;
  isAdmin = false;
  isOperator = false;
  isFermier = false;
  isAutoritateJudeteana = false;
  isContabil = false;

  exploatatieID;
  cod_exploatatie;
  nume_exploatatie;
  field_errors = {};
  disabledFields = {};

  constructor(
    private reproductionsTableService: ReproductionsTableService,
    private store: Store<ApplicationState>,
  ) { }

  ngOnInit(): void {
    this.isSuperAdmin = UIHelper.isSuperAdmin();
    this.isAdmin = UIHelper.isAdmin();
    this.isOperator = UIHelper.isOperator();
    this.isFermier = UIHelper.isFermier();
    this.isAutoritateJudeteana = UIHelper.isAutoritateJudeteana();
    this.isContabil = UIHelper.isContabil();
    this.buildForm();
  }

  ngOnChanges(changes) {
    if (changes.data) {
      if (this.data['monta_id']) {
        this.reprModalType = this.editReproduction;
        this.loadingDataSpinner = true;

        this.reproductionsTableService
          .getMonta({ monta_id: this.data['monta_id'] })
          .subscribe(response => {
            this.monta = response;
            this.buildForm(response);
            this.disabledFields = response ? response['disabled_fields'] : {};
            this.loadingDataSpinner = false;
          });
      } else {
        this.reprModalType = this.addReproduction;
        this.monta = null;
        this.buildForm();
      }
    }
  }

  ngOnDestroy() {
    this.destroy$.next(null);
    this.destroy$.unsubscribe();
  }

  buildForm(formData?) {
    if (!formData) {
      formData = {
        tip_reproductie: 2,
        status: this.defaultStatus(),
      };

      if (this.isAdmin || this.isOperator) {
        this.disabledFields = { 'status': false };
      } else {
        this.disabledFields = { 'status': true };
      }
    }

    this.reproductionForm = new UntypedFormGroup({
      exploatatie_id: new UntypedFormControl(formData['exploatatie_id']),
      anexa3id: new UntypedFormControl(formData['anexa3id'] || this.data['anexa_id']),
      monta_id: new UntypedFormControl(formData['monta_id']),
      tip_reproductie: new UntypedFormControl(formData['tip_reproductie']),
      status: new UntypedFormControl(formData['status']),
    });

    this.exploatatieID = formData['exploatatie_id'];
    this.cod_exploatatie = formData['cod_exploatatie'];
    this.nume_exploatatie = formData['nume_exploatatie'];

    if (!this.reproductionForm.value.exploatatie_id) {
      this.store.pipe(select(getSelectedHolding))
        .pipe(takeUntil(this.destroy$))
        .subscribe((response: any) => {
          if (!response) {
            return;
          }

          this.exploatatieID = response['id'];
          this.cod_exploatatie = response['code'];
          this.nume_exploatatie = response['name'];
          this.reproductionForm.controls.exploatatie_id.setValue(this.exploatatieID);
        });
    }
  }

  closeFormMethod() {
    this.closeForm.emit(false);
  }

  uploadMontaNaturala(event) {
    if (event.body && event.body.files) {
      const file = event.body.files[0];
      this.fileId = file.file_id;
      this.fileName = file.file_uploaded_name;
      this.reproductionForm.controls.file_id.setValue(file.file_id);
    }
  }

  openConfirmActionModal() {
    this.openConfirmModal = true;
  }

  closeConfirmModal(event) {
    this.openConfirmModal = false;
    if (event != true) {
      return;
    }

    this.reproductionsTableService
      .deleteReproductie(this.reproductionForm.value.monta_id)
      .subscribe({
        next: (response) => {
          this.callbackResult.emit(response);
          this.closeForm.emit(false);
        }
      });
  }

  onSubmitted() {
    if (!this.reproductionForm.valid) {
      return;
    }

    this.reproductionsTableService.salvareMontaAPI(this.reproductionForm.value)
      .subscribe({
        next: (response) => {
          this.callbackResult.emit(response);
          this.closeForm.emit(false);
        },
        error: (errors) => {
          this.field_errors = errors.error.field_errors || {};
        }
      });
  }

  schimbareTipReproductie(event) {
    this.monta = {
      tip_reproductie: event,
      status: this.reproductionForm.value.status,
    };

    this.buildForm(this.monta);
  }

  defaultStatus() {
    if (this.isAdmin) {
      return 3;
    }

    return 0;
  }

  // Get forms controls state
  get f() { return this.reproductionForm.controls; }
}
